<template lang="pug">
  .logo
    img(src="~assets/logo-main.png")

    
</template>

<script>
import gsap from 'gsap'
export default {
  name: 'Logo',
  data() {
    return {
      active: false,
      imgRatio: 0.29,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const w = window.innerWidth * 0.5
      const h = w * this.imgRatio
      const x = (window.innerWidth - w) / 2
      const y = (window.innerHeight / 2 - h) / 2
      const rect = this.$el.getBoundingClientRect()
      const scale = w / rect.width
      const dx = x - rect.x
      const dy = y - rect.y
      console.log(w, h, x, y, scale)
      gsap.set(this.$el, { x: dx, y: dy, scale: scale, opacity: 1 })
    },
    animeIn(dur) {
      gsap.to(this.$el, {
        x: 0,
        y: 0,
        scale: 1,
        duration: dur,
      })
    },
  },
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.logo
  width: 100%
  height: 100%
  opacity: 0
  line-height: 0
  //background: red
  transform-origin: left
  img
    width: 100%
    height: 100%
    object-fit: contain
</style>
